// extracted by mini-css-extract-plugin
export default {"actionButton":"lPkDzMyhovLQgbUMg3kQ","placeHolderShimmer":"XH7K7GYp7tufR4yVJKWv"};